module.exports = __webpack_public_path__ + "static/media/google-play-badge.f1b5aaa4.png";